import EventEmitter from 'es6-eventemitter';
import io from 'socket.io-client';
import Config from './../config';

export default class SocketClient {

    constructor(auth){
        this.authService = auth;
        this.events = new EventEmitter();
        this.queues = [];
        this.socket = null;

        this._initialize();
    }

    getCachedQueues(){
        return this.queues;
    }

    _initialize(){
        this.authService.events.on("LOGIN", () => {
            this.reconnect();
        });

        this.authService.events.on("LOGOUT", () => {
            this.disconnect();
        });
    }

    emit(event, data){
        this.socket.emit(event, data, (response) => {
            console.log('RESPONSE: ', response);
        });
    }

    subscribeToQueueChanges(queueName){
        this.socket.emit(Config.socket.events.SUBSCRIBE_TO_QUEUE, { queue: queueName }, function(response){
            console.log('RESPONSE subscribeToQueueChanges: ', response);
        });
    }

    unSubscribeFromQueueChanges(queueName){
        this.socket.emit(Config.socket.events.UNSUBSCRIBE_FROM_QUEUE, { queue: queueName }, function(response){
            console.log('RESPONSE unSubscribeToQueueChanges: ', response);
        });
    }

    disconnect(){
        if(this.socket){
            this.socket.close();
            delete this.socket;
        }
    }

    reconnect(){
        this.socket = io(Config.socketEndpoint, {
            query: {
                token: this.authService.getJwtToken()
            }
        });

        this.socket.on(Config.socket.events.QUEUES_UPDATE, (data) => {
            this.queues = data['queues'];
            this.events.emit('queues_updated', data);
        });

        this.socket.on(Config.socket.events.QUEUE_DETAILS, (data) => {
            this.events.emit('queue_details', data);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/socket.service.js